import { INVOICE_BALANCE_INCOMING_KEYS } from '../../constants/Invoice'
import { InvoiceAccountBalanceIncoming } from '../../models/Invoice'

export const orderLines = <T extends { key?: string }>(
    lines: T[]
): T[] =>
    [...(lines ?? [])].sort((a, b) =>
        (a.key ?? '').toLowerCase().localeCompare((b.key ?? '').toLowerCase())
    )

const PAYMENT_TYPE_VOLUME_LABELS: Record<string, string> = {
    stripe: 'Paiement en ligne',
    cash: 'Espèces',
    cb: 'Carte bancaire TPE',
    counter: 'Paiement au comptoir',
    to_driver: 'Paiement au livreur',
    ticket_resto: 'Tickets restaurants',
}

export const getVolumeLabel = (key?: string): string => {
    const paymentLabel = PAYMENT_TYPE_VOLUME_LABELS[(key ?? '').toLowerCase()]
    if (paymentLabel) {
        return `Volume transitant - ${paymentLabel} (TTC)`
    }
    return 'Volume transitant TTC'
}

export interface IncomingBalanceRow {
    key: INVOICE_BALANCE_INCOMING_KEYS
    label: string
    value: number
}

const SHOP_INCOMING_BALANCE_ORDER: INVOICE_BALANCE_INCOMING_KEYS[] = [
    INVOICE_BALANCE_INCOMING_KEYS.TOTAL,
    INVOICE_BALANCE_INCOMING_KEYS.STRIPE,
    INVOICE_BALANCE_INCOMING_KEYS.CASH,
    INVOICE_BALANCE_INCOMING_KEYS.TICKET_RESTO,
    INVOICE_BALANCE_INCOMING_KEYS.CB,
    INVOICE_BALANCE_INCOMING_KEYS.COUNTER,
    INVOICE_BALANCE_INCOMING_KEYS.TO_DRIVER
]

const SHOP_INCOMING_BALANCE_LABELS: Record<
    INVOICE_BALANCE_INCOMING_KEYS,
    string
> = {
    [INVOICE_BALANCE_INCOMING_KEYS.TOTAL]:
        'Volume transitant TOTAL (TTC)',
    [INVOICE_BALANCE_INCOMING_KEYS.STRIPE]:
        'Volume transitant - Paiement en ligne (TTC)',
    [INVOICE_BALANCE_INCOMING_KEYS.CB]:
        'Volume transitant - Carte bancaire TPE (TTC)',
    [INVOICE_BALANCE_INCOMING_KEYS.CASH]:
        'Volume transitant - Espèces (TTC)',
    [INVOICE_BALANCE_INCOMING_KEYS.TICKET_RESTO]:
        'Volume transitant - Tickets restaurants (TTC)',
    [INVOICE_BALANCE_INCOMING_KEYS.COUNTER]:
        'Volume transitant - Paiement au comptoir (TTC)',
    [INVOICE_BALANCE_INCOMING_KEYS.TO_DRIVER]:
        'Volume transitant - Paiement au livreur (TTC)'
}

const hasVisibleAmount = (
    key: INVOICE_BALANCE_INCOMING_KEYS,
    value?: number
) => {
    if (key === INVOICE_BALANCE_INCOMING_KEYS.TOTAL) {
        return typeof value === 'number'
    }

    return Number(value ?? 0) !== 0
}

export const getIncomingBalanceRows = (
    incoming: InvoiceAccountBalanceIncoming | undefined,
    isNetwork: boolean
): IncomingBalanceRow[] => {
    if (!incoming) {
        return []
    }

    const visibleKeys = isNetwork
        ? [INVOICE_BALANCE_INCOMING_KEYS.TOTAL]
        : SHOP_INCOMING_BALANCE_ORDER

    return visibleKeys
        .filter((key) => hasVisibleAmount(key, incoming[key]))
        .map((key) => ({
            key,
            label: isNetwork
                ? 'Commissions totales (TTC)'
                : SHOP_INCOMING_BALANCE_LABELS[key],
            value: incoming[key] ?? 0
        }))
}

export const getBalanceFormulaText = (isNetwork: boolean): string => {
    if (isNetwork) {
        return 'Commissions totales - Montant dû TTC total'
    }

    return 'Volume transitant via paiement en ligne - Montants dûs'
}
